<label class="flex leading-[20px]">
  <input
    class="checkbox !mr-[10px]"
    [attr.data-testid]="testId()"
    type="checkbox"
    [formControl]="control()"
    [tabindex]="tabIndex()"
    [required]="required()"
  />

  <span class="flex text-[15px]" [innerHTML]="title() || '—'"></span>
</label>

@if (
  control().errors
    | isErrorColored: control().dirty && control().invalid : validationErrors()
) {
  <shared-form-error
    [errors]="control().errors"
    [validationErrors]="validationErrors()"
  >
  </shared-form-error>
}
